import { fetchArtworks } from '../api'
import { firebaseAction } from 'vuexfire'
import Vue from 'vue'

export default {
  setTouchable ({ commit, state }, value) {
    commit('SET_TOUCHABLE', value)
  },

  setRef: firebaseAction(({ bindFirebaseRef }, payload) => {
    bindFirebaseRef(payload.key, payload.ref, { wait: false })
  }),
  unsetRef: firebaseAction(({ unbindFirebaseRef }, key) => {
    unbindFirebaseRef(key)
  }),

  FETCH_ITEMS: ({ commit, state }, { ids }) => {
    // only fetch items that we do not already have, or has expired (3 minutes)
    const now = Date.now()
    ids = ids.filter(id => {
      const item = state.items[id]
      if (!item) {
        return true
      }
      return now - item.__lastUpdated > 1000 * 60 * 3
    })
    if (ids.length) {
      return fetchArtworks(ids).then(items => commit('SET_ITEMS', { items }))
    } else {
      return Promise.resolve()
    }
  },

  /**
   * @param commit=
   * @param state=
   * @param {number} artworkId
   * @param {number} setupIndex
   * @param {DisplaySetup} setup
   */
  updateAccountDisplaySetup ({ commit, state }, { artworkId, setupIndex, setup }) {
    // THE LOCAL STORAGE IS ONLY FOR DEVELOPMENT .. SHOULD BE REMOVED
    const accountLocalStorage = Vue.$storage.get(state.userAccount['.key'], {})
    if (!accountLocalStorage.displaySetups) accountLocalStorage.displaySetups = {}
    if (!accountLocalStorage.displaySetups[artworkId]) accountLocalStorage.displaySetups[artworkId] = []
    accountLocalStorage.displaySetups[artworkId][setupIndex] = { ...setup, startedAt: Date.now() }
    Vue.$storage.set(state.userAccount['.key'], accountLocalStorage)

    commit('UPDATE_DISPLAY_SETUPS', { artworkId, setupIndex, setup })
  }
}
